import { inject, NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { NotAuthorizedGuard } from "./guards";

const routes: Routes = [
  {
    path: "iam/sign-in",
    runGuardsAndResolvers: "always",
    canActivate: [() => inject(NotAuthorizedGuard).canActivate()],
    loadChildren: () =>
      import("@youm-front/iam-account/feature/sign-in").then(
        (m) => m.IamAccountFeatureSignInModule
      )
  },
  { path: "**", redirectTo: "", pathMatch: "full" }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: "reload"
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
